module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAA70lEQVQ4T6WQzSqFYRSFn+Ue3IO5uWswNqGI0iEDQhGiODEQEqKYGLsHcxdy3IOlfVqdvsPnL2u0373Xetr7Ff+UbI8Bo5Ke/8KyPQH0CtArALAt6eA3ENtbwD7wWoArYCHBI0mb30FsHwIb8VwXQMAFsJjmGbAiyU1QfKfAcvqXQKfCfdk+BlbzvAPmJb1lNgLcALOZn0haq3oAiHEX2InpEZhO/QBMpd6TVL6+hgCBFLmb2VN8k7UksC6pNh3oEyCQ+o9zoFYv1SlLkuruIbUCApkBbuOek3T/Mdx6QtNke7xWl/TSFv4R8FWo2X8HnupPrMo1ch0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jt.png
// module id = DmtO
// module chunks = 1